import React, {useState} from 'react';
import { useDispatch } from 'react-redux';
import {Box} from "@mui/material";
import OrganisationForm from './OrganisationForm';

import { updateOrganisation } from '../../redux-store/currentUserActions';
import { useSnackbar } from "../../contexts/CustomSnackbarContext";

const OrganisationSettings = ({organisation, onUpdate}) => {
  const dispatch = useDispatch();
  const {openSnackbar} = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (data={}) => {
    setIsLoading(true);
    const response = await dispatch(updateOrganisation({id: organisation.id, name: data.companyName, host: data.host, location: data.companyLocation}));
    if (response?.payload) {
      openSnackbar({ message: "Organisation updated successfully!", severity: 'success' });
      onUpdate();
      setIsLoading(false);
    } else {
      openSnackbar({ message: "Organisation updation failed!", severity: 'error' });
      setIsLoading(false);
    }
  }

  return (
    <Box>
      <OrganisationForm organisation={organisation} onSubmit={handleSubmit} isLoading={isLoading} actionType="edit" />
    </Box>
  )
}

export default OrganisationSettings;
